import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { DataTableItem, DataTableItemAction, DataTableRow } from './index';

export interface HeaderWithOrderBy {
  text: string;
  OrderByField?: string;
}

export interface DataTableProps {
  ColumnWidths?: number[];
  DeleteItem?: (Id: string) => void;
  Header?: string[];
  HeaderWithOrderByLinks?: HeaderWithOrderBy[];
  IsHoverable?: boolean;
  ItemActions?: (Id: string) => DataTableItemAction[];
  Items: DataTableItem[];
  LegendText?: string;
  TotalItems?: number;
  OpenInNewWindow?: boolean;
  Ascending?: boolean;
  HideDeleteButton?: boolean;
  OnHeaderClick?: (OrderByField: string) => void;
  SelectedOrderByField?: string;
}

const DataTable = ({
  ColumnWidths = null,
  DeleteItem = null,
  Header,
  HeaderWithOrderByLinks,
  IsHoverable = true,
  ItemActions = null,
  Items,
  LegendText = '',
  TotalItems = null,
  OpenInNewWindow,
  Ascending = true,
  OnHeaderClick,
  SelectedOrderByField,
  HideDeleteButton = false,
}: DataTableProps) => {
  const generateKey = (pre: string, index: number) => {
    const formattedPre = encodeURIComponent(pre.substring(0, 20));
    return `${formattedPre}_${index}`;
  };
  if (Items !== null && Items !== undefined && Items && Items.length > 0) {
    return (
      <>
        {LegendText !== '' && (
          <div className="mb-16">
            <p className="mb-0">
              {TotalItems !== null ? TotalItems : Items.length} {LegendText}
            </p>
          </div>
        )}
        <Card className="bg-white border shadow-none">
          <div className="table-responsive-lg">
            <Table hover={IsHoverable} className="datatable">
              <thead>
                <tr className="datatable-head-row">
                  {HeaderWithOrderByLinks === undefined &&
                    Header.map((item, index) => (
                      <th
                        key={generateKey(item, index)}
                        className="datatable-head small p-8 px-16"
                      >
                        {item}
                      </th>
                    ))}
                  {HeaderWithOrderByLinks !== undefined &&
                    HeaderWithOrderByLinks.map((item, index) => (
                      <th
                        key={generateKey(item.text, index)}
                        className={`datatable-head small p-8 px-16 ${
                          item.OrderByField && OnHeaderClick
                            ? 'text-decoration-underline'
                            : ''
                        }`}
                        onClick={() => {
                          if (item.OrderByField) {
                            (OnHeaderClick ?? (() => {}))(item.OrderByField);
                          }
                        }}
                      >
                        {item.text}{' '}
                        {item.OrderByField === SelectedOrderByField &&
                          Ascending && (
                            <i className="text-success body-regular bi-caret-up-fill" />
                          )}
                        {item.OrderByField === SelectedOrderByField &&
                          !Ascending && (
                            <i className="text-success body-regular bi-caret-down-fill" />
                          )}
                      </th>
                    ))}
                  {DeleteItem !== null &&
                    Items[0].ItemId !== null &&
                    Items[0].ItemId !== undefined && (
                      <th className="datatable-head small p-8 px-16">
                        Toiminnot
                      </th>
                    )}
                </tr>
              </thead>
              <tbody>
                {Items.map((item, index) => (
                  <DataTableRow
                    ColumnWidths={ColumnWidths}
                    DeleteItem={DeleteItem}
                    key={generateKey(item.ItemId, index)}
                    Item={item}
                    ItemActions={ItemActions}
                    HideDeleteButton={HideDeleteButton}
                    OpenInNewWindow={OpenInNewWindow}
                  />
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </>
    );
  }

  return null;
};

// DataTable.defaultProps = {
//   ColumnWidths: null,
//   DeleteItem: null,
//   IsHoverable: true,
//   ItemActions: null,
//   LegendText: '',
//   TotalItems: null,
// };

export default DataTable;
export { DataTable };
